import { render } from "./browserUses.vue?vue&type=template&id=3a3a4a3a"
import script from "./browserUses.vue?vue&type=script&lang=js"
export * from "./browserUses.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__